<template>
    <div>

        <div id="hello-hello">
            <p style="display:inline;float: left;line-height: 22px;"><b>-首检列表</b></p>
        </div>

        <el-table :data="inspectionList" style="width: 100%" highlight-current-row>

            <el-table-column prop="customer" label="客户" min-width="15%">
            </el-table-column>

            <el-table-column prop="productName" label="产品" min-width="30%">
            </el-table-column>

            <el-table-column prop="updatedTime" label="首检时间" min-width="20%">
            </el-table-column>

            <el-table-column prop="maker" label="首检人" min-width="10%">
            </el-table-column>
            <el-table-column prop="remark" label="说明" min-width="25%">
            </el-table-column>

            <el-table-column fixed="right" label="操作" width="80">
                <template slot-scope="scope">
                    <el-button @click="handleClick(scope.row)" type="success" round size="small">
                        详情
                    </el-button>
                </template>
            </el-table-column>
        </el-table>

        <!-- 分页 -->
        <div>
            <el-pagination background :page-size="pageNum" :page-count="pageCount" layout="total, sizes, prev, pager, next"
                :total="total" @current-change="pageClick" :page-sizes="[8, 12, 16, 20]" @size-change="handleSizeChange">
            </el-pagination>
        </div>

        <el-dialog title="首检详情" :visible.sync="dlgFormVisible" width="45%">

            <div style="background-color: #f5f7fa;font-size: 14px;text-align:left;padding: 15px 0 15px 10px;margin-bottom: 10px;">
                <span>产品：</span>
                <span style="color:green;font-weight: bold;">{{ form.productName }}</span>
            </div>

            <div style="display:flex;margin-bottom: 10px;">
                <p style="display:inline;margin-right: 10px;">上传的图片</p>

                <div style="display:inline-block;width:132px">
                    <el-image :src="'https://' + imagePath + form.inspectionPicOne"
                        v-if="form.inspectionPicOne == '' ? false : true"></el-image>
                </div>
            </div>

            <div style="display:flex;margin-bottom: 10px;">
                <p style="display:inline;margin-right: 10px;">说明</p>
                <div style="display:inline">
                    <el-input v-model="form.remark" autocomplete="off" type="textarea"
                        style="width:540px" disabled></el-input>
                </div>
            </div>

            <div style="background-color: #f5f7fa;color:green;font-size: 14px;text-align:left;padding: 15px 0 15px 10px;">
                首检项目
            </div>

            <div v-for="item in inspectionItemList" :key="item.id" style="display:flex">
                <p style="text-align: left;width:70%">{{ item.inspectionName }}</p>

                <div style="display:inline-block;line-height: 40px;margin: 5px 0;">
                    <el-tag :type="item.status == 1 ? 'success' : 'danger'">{{ item.status == 1 ? '正常' : '异常' }}</el-tag>
                </div>
            </div>

            <div slot="footer" class="dialog-footer">
                <el-button @click="dlgFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="saveInspectionClick('ruleForm')">保 存</el-button>
            </div>
        </el-dialog>

    </div>
</template>

<script>
export default {
    name: "OrderInspection",
    data() {
        return {
            token: this.getToken(),
            companyId: this.getCompanyId(),
            imagePath: this.getImagePath(),

            inspectionList: [],

            dlgFormVisible: false,
            
            form: {
                id: '',
                customer: '',

                productList: [],
                productId: '',
                productName: '',

                status: 0,
                remark: '',
                inspectionPicOne:''
            },
            loading: false,

            formLabelWidth: '120px',

            inspectionItemList: [],

            pageIndex: 0,
            pageNum: 8,
            total: 0,
            pageCount: 0
        }
    },
    methods: {
        //详情按钮
        handleClick(row) {
            
            this.form.id = row.id

            this.form.maker = row.maker

            this.form.productName = row.productName

            this.form.inspectionPicOne=row.inspectionPicOne

            this.form.remark = row.remark

            this.getInspectionItem(row.id)

            this.dlgFormVisible = true
        },
        getInspectionItem(val) {

            this.$axios({
                method: "post",
                url: "/shiro/inspection/item/getAll",
                data: {
                    orderInspectionId: val,
                    companyId: this.companyId
                },
                headers: {
                    token: this.token
                }
            }).then(result => {

                const data = result.data

                this.inspectionItemList = data.data
            })
        },
        getAll() {

            this.$axios({
                method: "post",
                url: "/shiro/order/inspection/getAll",
                data: {
                    pageIndex: this.pageIndex,
                    pageNum: this.pageNum,
                    companyId: this.companyId
                },
                headers: {
                    token: this.token
                }
            }).then(result => {

                const data = result.data

                if (data.status === 400) {
                    this.$router.push({ path: "/Login" })
                }

                if (data.status === 202) {
                    this.$notify({
                        title: '重要提示',
                        message: data.msg,
                        duration: 0
                    })
                    return
                }

                if (data.status != 200) {
                    this.$message({
                        type: 'info',
                        message: data.msg
                    })
                    return
                }

                this.inspectionList = data.data
                this.total = this.inspectionList[0].total
                for (let i in this.inspectionList) {
                    this.inspectionList[i].updatedTime = this.$moment(this.inspectionList[i].updatedTime).format("YYYY-MM-DD HH:mm")
                }
            })
        },
        pageClick(currentPage) {
            this.inspectionList = []

            this.pageIndex = (currentPage - 1) * this.pageNum
            this.getAll()
        },
        handleSizeChange(val) {
            this.pageNum = val

            this.getAll()
        }
    },
    mounted() {
        this.setDefaultPath('/orderInspection')

        this.getAll()
    }
}
</script>

<style>
#create_work {
    position: relative;
    right: 5px;
    width: 120px;
}

.DisabledSelection .el-checkbox__inner {
    display: none;
    position: relative;
}

.el-pagination__total {
    color: green;
}
</style>